var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 322.4 64.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5b3d3a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "disgusted"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.9,64.73A8.09,8.09,0,0,1,0,60.07a15.83,15.83,0,0,1,1.2-4.5A35.59,35.59,0,0,1,6,47.89,86.81,86.81,0,0,1,18.48,35.4,156.12,156.12,0,0,1,32.68,25q7.41-4.71,15.24-8.73c5.2-2.64,10.38-5.42,15.82-7.85A63.82,63.82,0,0,1,81,3.39a54.56,54.56,0,0,1,18.67.36c6.19,1.27,12.37,4.17,16.4,8.9l-.7,1.21a50.61,50.61,0,0,0-16.22-.18,111.69,111.69,0,0,0-15.3,3.45c-5.08,1.47-10.23,3-15.54,4.33a143.21,143.21,0,0,0-15.85,5c-5.19,2-10.29,4.22-15.29,6.65A153.55,153.55,0,0,0,22.54,41a86.34,86.34,0,0,0-13.35,9.8,32.63,32.63,0,0,0-5.33,6.09c-1.42,2.19-2.48,4.77-1.69,7.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M320.37,56.12c.67-2.49-.52-5-2-7.11a32.35,32.35,0,0,0-5.61-5.8A85.82,85.82,0,0,0,299,34.13,152.59,152.59,0,0,0,284,27q-7.65-3.26-15.55-5.85a115,115,0,0,0-15.95-4c-5.33-1-10.55-2-15.73-3.1a157.16,157.16,0,0,0-15.67-2.5c-2.64-.27-5.31-.44-8-.45a51.59,51.59,0,0,0-8.36.6l-.7-1.21a20.18,20.18,0,0,1,3.44-3.15,27.15,27.15,0,0,1,4-2.48,40.94,40.94,0,0,1,8.77-3.24A60.15,60.15,0,0,1,238.51.14a62,62,0,0,1,17.6,3.76c5.62,2,11,4.5,16.35,6.88s10.53,5.05,15.6,7.93a156.9,156.9,0,0,1,14.65,9.59,86.45,86.45,0,0,1,13.07,11.81,35.57,35.57,0,0,1,5.1,7.41,15.44,15.44,0,0,1,1.41,4.42,8.09,8.09,0,0,1-.61,4.68Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset50);
export default __webpack_public_path__ + "static/media/Asset 50.c6cbab3d.svg";
export { ForwardRef as ReactComponent };